var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { ToggleIsClientModalData } from './toggle.is.client.modal.provider';
var ToggleIsClientModalComponent = /** @class */ (function (_super) {
    __extends(ToggleIsClientModalComponent, _super);
    function ToggleIsClientModalComponent(fb, accountApiService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.account = Object.assign({}, data);
        return _this;
    }
    ToggleIsClientModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.accountApiService.getIsClient(this.account.account._id).subscribe(function (toggle) {
            if (toggle) {
                _this.account.account.isClientAccount = isNullOrUndefined(toggle.isClientAccount) ? true : toggle.isClientAccount;
            }
            _this.loading = false;
        });
    };
    ToggleIsClientModalComponent.prototype.toggleIsClientAccount = function () {
        var _this = this;
        this.account.account.isClientAccount = !this.account.account.isClientAccount;
        this.accountApiService.toggleIsClientAccount(this.account.account._id, this.account.account.isClientAccount).subscribe(function (data) {
            _this.success.success();
        });
    };
    ToggleIsClientModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return ToggleIsClientModalComponent;
}(BaseComponent));
export { ToggleIsClientModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/toggle.is.client/toggle.is.client.modal.component.ts.pre-build-optimizer.js